module.exports = __webpack_public_path__ + "stylesheets/video-player_730cdd2c53e474e6494582ade0667467.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/video-player.less
// module id = pbA1
// module chunks = 51